import { Moon, Sun } from 'lucide-react'
import { LANDING_PAGE_UI } from '@propbix/constants/public'
import { useTheme } from '@/theme/theme-context'

export function ThemeToggle() {
  const { resolved, toggleLightDark } = useTheme()
  const isDark = resolved === 'dark'

  return (
    <button
      type="button"
      onClick={toggleLightDark}
      className="inline-flex size-11 items-center justify-center rounded-[var(--radius-control)] border border-line/15 bg-surface text-ink transition-[transform,background-color,border-color] duration-200 hover:border-line/30 hover:bg-panel active:scale-[0.97]"
      aria-label={isDark ? LANDING_PAGE_UI.themeToggleLight : LANDING_PAGE_UI.themeToggleDark}
    >
      {isDark ? <Sun size={18} strokeWidth={1.75} /> : <Moon size={18} strokeWidth={1.75} />}
    </button>
  )
}
